import { BrandMark } from "@/components/BrandMark";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/Primitives";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (ex) { setErr(errMsg(ex)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm rise" data-testid="forgot-password-page">
        <div className="flex items-center gap-3 mb-10"><BrandMark className="h-10 w-10" textClass="text-xl" /><span className="font-heading font-semibold text-lg">Yutaka CRM <span className="text-xs italic text-primary font-normal">— Grow Together be Stronger</span></span></div>
        {sent ? (
          <div data-testid="forgot-password-sent" className="surface p-8 text-center">
            <MailCheck className="h-10 w-10 mx-auto text-primary mb-4" />
            <h2 className="font-heading text-xl font-semibold">Periksa email Anda</h2>
            <p className="text-sm text-muted-foreground mt-2">Jika <span className="font-mono">{email}</span> terdaftar, kami telah mengirim tautan reset password yang berlaku 1 jam.</p>
            <Button asChild variant="outline" className="mt-6" data-testid="forgot-back-login"><Link to="/login">Kembali ke login</Link></Button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p className="eyebrow mb-2">Lupa Password</p>
            <h2 className="font-heading text-2xl font-semibold mb-2">Pulihkan akses Anda</h2>
            <p className="text-sm text-muted-foreground mb-8">Masukkan email akun Anda. Kami akan mengirim tautan untuk mengatur ulang password.</p>
            <div className="space-y-4">
              <Field label="Email"><Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="nama@lembaga.id" /></Field>
              {err && <p data-testid="forgot-error" className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2">{err}</p>}
              <Button data-testid="forgot-submit-button" type="submit" className="w-full h-11" disabled={loading}>{loading ? "Mengirim..." : "Kirim Tautan Reset"}</Button>
            </div>
            <Link to="/login" data-testid="forgot-back-link" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mt-6"><ArrowLeft className="h-4 w-4" />Kembali ke login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
